module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/coursefinder-mail-db4d345d86eed131a4b5707c79fbc91a.svg";